"use client"

// src/components/infinite-scroll-area.ts
var InfiniteScrollArea = {
  baseStyle: {
    container: {},
    trigger: {}
  },
  defaultProps: {}
};

export {
  InfiniteScrollArea
};
//# sourceMappingURL=chunk-2OIEHK73.mjs.map